import React from 'react';
import StarRating from 'components/StarRating';
import { IGoogleReview } from '../../constants';
import css from './GoogleReviewCard.module.scss';

export default function GoogleReviewCard({
  img,
  name,
  rating,
  time,
  positive,
  description,
  link
}: IGoogleReview) {
  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <div className={css.img}>{img}</div>
        <div className={css.name}>{name}</div>
      </div>
      <div className={css.subtitle}>
        <div className={css.rating}><StarRating rating={rating} fontSize={1}/><span>{time}</span></div>
        <div className={css.positive}>Positive: <span>{positive}</span></div>
      </div>
      <div className={css.description}>
        {description}
        <a href={link} target="_blank">More</a>
      </div>
    </div>
  )
}
